import { forwardRef, type InputHTMLAttributes } from 'react';
import { useController, type Control, type FieldPath, type FieldValues } from 'react-hook-form';
import { FieldError } from './FieldError';
import { formatDateDmy } from './utils';

interface Props<T extends FieldValues>
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'name' | 'defaultValue'> {
  name: FieldPath<T>;
  control: Control<T>;
  label?: string;
}

const Component = <T extends FieldValues>({ name, control, label, ...rest }: Props<T>) => {
  const {
    field,
    fieldState: { error },
  } = useController({ name, control });

  return (
    <div>
      {label && <label className="lbl">{label}</label>}
      <input
        {...rest}
        ref={field.ref}
        name={field.name}
        value={(field.value as string) ?? ''}
        onChange={(e) => field.onChange(formatDateDmy(e.target.value))}
        onBlur={field.onBlur}
        placeholder="dd/mm/yyyy"
        maxLength={10}
        inputMode="numeric"
        className={`inp ${error ? 'inp-error' : ''}`}
        aria-invalid={!!error}
      />
      <FieldError message={error?.message} />
    </div>
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DateInput = forwardRef(Component as any) as unknown as <T extends          
  FieldValues>(     
  p: Props<T>,
) => JSX.Element;
